import { AppSettings } from "@/settings"

import configAndLocales from "../../statics/json/configAndLocals.json"

export const getLocaleStrings = (locale = AppSettings.defaultLocale()) => {
  return configAndLocales[locale].localeStrings
}
